import { ErrorHandler, Injectable } from '@angular/core';

export function isChunkLoadError(err: unknown): boolean {
  const e = err as { name?: unknown; message?: unknown };
  return (
    e?.name === 'ChunkLoadError' ||
    (typeof e?.message === 'string' &&
      (e.message.toLowerCase().includes('chunkloaderror') ||
        e.message
          .toLowerCase()
          .includes('failed to fetch dynamically imported module')))
  );
}

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (isChunkLoadError(error)) {
      window.location.reload();
      return;
    }
  }
}
